export default function loopDestroy() {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params,
      slides = swiper.slides;
  $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + ",." + params.slideClass + "." + params.slideBlankClass).remove();
  slides.removeAttr('data-swiper-slide-index');
}


//////////////////
// WEBPACK FOOTER
// ./~/swiper/esm/components/core/loop/loopDestroy.js
// module id = 1168
// module chunks = 168